module.exports = __webpack_public_path__ + "static/img/baby_1.5ed846c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baby_1.png
// module id = Vizg
// module chunks = 1